import { render, staticRenderFns } from "./tech-parameters.vue?vue&type=template&id=52c59dae&scoped=true"
import script from "./tech-parameters.vue?vue&type=script&lang=js"
export * from "./tech-parameters.vue?vue&type=script&lang=js"
import style0 from "./tech-parameters.vue?vue&type=style&index=0&id=52c59dae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c59dae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/apps/wpms/web/wind-plannerDev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c59dae')) {
      api.createRecord('52c59dae', component.options)
    } else {
      api.reload('52c59dae', component.options)
    }
    module.hot.accept("./tech-parameters.vue?vue&type=template&id=52c59dae&scoped=true", function () {
      api.rerender('52c59dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-manage/components/tech-parameters.vue"
export default component.exports